import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { of, Observable } from 'rxjs';

import { environment } from 'environments/environment';

import { DateHelpers } from '../dateHelpers';
import { Video } from '@classes/video';
import { ChangeLog } from '@classes/changeLog/changeLog';
import { AppConfigService } from './app-config.service';

@Injectable({
    providedIn: 'root'
})
export class HelpService {

    private baseUrl: string = environment.apiUrl + 'help/';

    constructor(
        private http: HttpClient,
        private configSrv: AppConfigService
    ) { }

    getVideos(): Observable<Video[]> {
        return this.http.get<Video[]>(`${this.baseUrl}tutorials`);
    }

    isUnderMaintenance(): Observable<boolean> {
        if (this.configSrv.isMaintenance)
        {
            return of(true);
        }
        return this.http.get<boolean>(`${this.baseUrl}isundermaintenance`);
    }

    hasChangLog(minDate: Date = null): Observable<boolean> {
        const params = new HttpParams().append("minDate", DateHelpers.toHttpParameter(minDate));
        return this.http.get<boolean>(`${this.baseUrl}haschangelog`, {params});
    }
    getChangLog(minDate: Date = null): Observable<ChangeLog> {
        const params = new HttpParams().append("minDate", DateHelpers.toHttpParameter(minDate));
        return this.http.get<ChangeLog>(`${this.baseUrl}changelog`, {params});
    }
}
